export const useHeaderHeight = () => {
  const getHeaderHeight = (() => {
    const header = document.getElementById('page-header')
    const headerHeight = header?.clientHeight ?? 0
    return `${headerHeight}px`
  })()
  return getHeaderHeight
}
